import styles from './profile-pic-viewer-style.module.css';

export default function ProfilePicViewer({profilePic, firstInitial, size, onPicClicked, id=null}) {



    if(profilePic != null && profilePic[0] === '#') {

        return (
            <div id={id} className={styles.background} style={{width: size+'px', height: size+'px', background: profilePic}}>
                <h1 className={styles.text} style={{color: 'white', fontSize: (size/1.25)+'px', height: size+'px', lineHeight: size+'px'}}>
                    {firstInitial}
                </h1>
                {
                    onPicClicked != null ? 
                    (<div className={styles.cover} onClick={() => {onPicClicked()}}/>) : null
                }
                
            </div>
        );
    } else if (profilePic != null && profilePic[0] === 'd'){
        return (
            <div id={id} className={styles.background} style={{width: size+'px', height: size+'px'}}>
                <img className={styles.image} src={profilePic}/>
                {
                    onPicClicked != null ? 
                    (<div className={styles.cover} onClick={() => {onPicClicked()}}/>) : null
                }
                
            </div>
        );
    } else {
        return (
            <div id={id} className={styles.background} style={{width: size+'px', height: size+'px', background: '#0BBECF'}}>
                <h1 className={styles.text} style={{color: 'white', fontSize: (size/1.25)+'px', height: size+'px', lineHeight: size+'px'}}>
                    C
                </h1>
                {
                    onPicClicked != null ? 
                    (<div className={styles.cover} onClick={() => {onPicClicked()}}/>) : null
                }
                
            </div>
        );
    }
}
